

const stepsContainer = '#dr_order_steps';
const stepsProgress = '#jprogress_bar';
const defaultOrderPageHead = $('#orderProcessHeading').text();

$(document).ready(function(){
  $(document).on('click', 'button.dr_op_next', function(){
    op_nextStep(stepsContainer);
  });

  $(document).on('click', 'button.dr_op_back', function(){
    op_backStep(stepsContainer);
  });

  op_preLoadTab();

  op_computeProgress(stepsContainer, stepsProgress);

  $(document).on('change', '.line-item-property__field.with-highlight input[type=checkbox]', function(){
    drHighLightCheckBox(this);
  });
  $(document).on('change', '.line-item-property__field.with-highlight input[type=radio]', function(){
    drHighLightCheckBox(this);
  });

  preDrHighLightCheckBox();

  $('.dr_op_back').attr('disabled', false);
  $('.dr_op_next').attr('disabled', false);



  if (window.history && window.history.pushState) {
    // window.history.pushState('forward', null, './#forward');

    $(window).on('popstate', function() {
      var the_tab_hash = window.location.hash;

      if(the_tab_hash != ""){
        $('#dr_order_steps .dr-op-step').removeClass('active');
        $('#dr_order_steps .dr-op-step' + the_tab_hash).addClass('active');

        if($('#dr_order_steps .dr-op-step.active').data('heading_override')){
          $('#orderProcessHeading').text($('#dr_order_steps .dr-op-step.active').data('heading_override'));
        }else{
          $('#orderProcessHeading').text(defaultOrderPageHead);
        }

        $([document.documentElement, document.body]).animate({
          scrollTop: $("#MainContent").offset().top
        }, 800);

        op_computeProgress(stepsContainer, stepsProgress);
        op_remove_alert();
      }
    });
  }

});

function op_preLoadTab(){
  var the_tab_hash = window.location.hash;
  
  if(the_tab_hash != ""){
    if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      $('#dr_order_steps .dr-op-step').removeClass('active');
      $('#dr_order_steps .dr-op-step' + the_tab_hash).addClass('active');

      $([document.documentElement, document.body]).animate({
        scrollTop: $("#MainContent").offset().top
      }, 800);

    op_computeProgress(stepsContainer, stepsProgress);
      op_remove_alert();
    }
  }else{
    var current_active_tab = $('.dr-op-step.active');
    op_check_tab_id(current_active_tab);
  }
  

  if($('#dr_order_steps .dr-op-step.active').data('heading_override')){
    $('#orderProcessHeading').text($('#dr_order_steps .dr-op-step.active').data('heading_override'));
  }else{
    $('#orderProcessHeading').text(defaultOrderPageHead);
  }
}



$(document).on('change', '#dr_i_logo_txt', function(){
  drILogoText(this);
});

$(document).on('keyup', '#dr_i_logo_txt', function(){
  drILogoText(this);
});

const drILogoText = (el) => {
  $('#dr_chk_i-16').val(el.value);
};

$(document).on('click', '#dr_i_logo_txt', function(){
  /* $(this).next('input[type=checkbox]').click(); */
  let lastchkbox = $(this).next('input[type=checkbox]')
  $('input:checkbox').not(lastchkbox).prop('checked', false);
  lastchkbox.prop('checked', true);
  drHighLightCheckBox(lastchkbox);
});


function drHighLightCheckBox(el){
  let selectedItem = $(el);
  let sContainer = selectedItem.closest('.line-item-property__field');
  sContainer.find('label').removeClass('active');

  sContainer.find('label').each(function(){
    if($(this).find('input').is(':checked')){
      $(this).addClass('active');
    }
  });
}

function preDrHighLightCheckBox(){
  $('.line-item-property__field.with-highlight').find('label').each(function(){
    if($(this).find('input').is(':checked')){
      $(this).addClass('active');
    }
  });
}
$('.line-item-property__field[data-dr_type=radio] input:checkbox').click(function() {
  $('input:checkbox').not(this).prop('checked', false);
});

$(window).click(function(e) {
  if($(e.target).hasClass('dr-op-container')
     || $(e.target).hasClass('page-width')
     || $(e.target).hasClass('dr-section')
     || $(e.target).hasClass('dr-heading')
     || $(e.target).hasClass('content-for-layout')
     || $(e.target).hasClass('dr-op-box-choice')
     || $(e.target).hasClass('dr-op-footer')
     || $(e.target).hasClass('dr-white-space')
     || $(e.target).hasClass('dr-op-alert')){
    $('.dr-op-step.active .line-item-property__field.with-highlight .dr-op-box-choice label').each(function(){
      $(this).find('input').prop('checked', false);
      drHighLightCheckBox(this);
    });
  }
});

function op_nextStep(targetElement){
  console.log("Next STEP!");
  const activeElement = $(targetElement).find('.dr-op-step.active');

  if(dr_basic_validation(activeElement)){
    $(targetElement).find('.dr-op-step').removeClass('go-next');
    $(targetElement).find('.dr-op-step').removeClass('go-prev');

    $(activeElement).removeClass('active');
    $(activeElement).next('.dr-op-step').addClass('active');
    $(activeElement).next('.dr-op-step').addClass('go-next');

    if($(activeElement).next('.dr-op-step').data('heading_override')){
      $('#orderProcessHeading').text($(activeElement).next('.dr-op-step').data('heading_override'));
    }else{
      $('#orderProcessHeading').text(defaultOrderPageHead);
    }

    $([document.documentElement, document.body]).animate({
      scrollTop: $("#MainContent").offset().top
    }, 800);

    op_computeProgress(stepsContainer, stepsProgress);
    op_remove_alert();
    
	op_check_tab_id($(activeElement).next('.dr-op-step'));
  }else{
    if($(activeElement).data('warning_msg')){
      op_render_alert(targetElement, $(activeElement).data('warning_msg'));
    }else{
      op_render_alert(targetElement, 'Bitte tragen Sie Ihren Firmennamen und/oder Slogan ein!');
    }
  }
}

function op_render_alert(container, msg){
  $(container).find('.dr-op-footer').find('.dr-op-alert').remove();
  let msgHtml = '<div class="dr-op-alert">' + msg + '</div>';
  $(container).find('.dr-op-footer').prepend(msgHtml);
}
function op_remove_alert(){
  $('.dr-op-alert').remove();
}

function op_backStep(targetElement){
  $(targetElement).find('.dr-op-step').removeClass('go-next');
  $(targetElement).find('.dr-op-step').removeClass('go-prev');

  const activeElement = $(targetElement).find('.dr-op-step.active');
  $(activeElement).removeClass('active');
  $(activeElement).prev('.dr-op-step').addClass('active');
  $(activeElement).prev('.dr-op-step').addClass('go-prev');

  if($(activeElement).prev('.dr-op-step').data('heading_override')){
    $('#orderProcessHeading').text($(activeElement).prev('.dr-op-step').data('heading_override'));
  }else{
    $('#orderProcessHeading').text(defaultOrderPageHead);
  }

  op_computeProgress(stepsContainer, stepsProgress);
  op_remove_alert();
  op_check_tab_id($(activeElement).prev('.dr-op-step'));
}

function op_check_tab_id(the_tab){
  var op_tab_id = $(the_tab).attr('id');
  if(op_tab_id !== undefined && op_tab_id != "" && op_tab_id != null){
  	window.history.pushState('', '', window.location.pathname+'#'+op_tab_id);
  }else{
  	window.history.pushState('', '', window.location.pathname);
  }
}

function op_computeProgress(container, bar){
  const stepCount = $(container + ' div.dr-op-step').length;
  let singleProgress = 100 / stepCount;
  let newProgress = 0;
  let step = 1;
  let continueStep = true;
  let isLastChild = false;
  $(container + ' div.dr-op-step').each(function(){
    if(continueStep){
      newProgress = step * singleProgress;
      step++;
      if($(this).hasClass('active')){
        continueStep = false;
      }
      if($(this).is(':last-child')){
        isLastChild = true;
      }else{
       	isLastChild = false; 
      }
    }
  });
  
  if(newProgress == 100 || isLastChild){
    newProgress = 98; 
  }else{
    $(bar).find('i').text('');
  }
  $(bar).css('width', newProgress+'%');
  $(bar).find('span').text(Math.trunc(newProgress)+'%');
}

function noSubmit(e){
  e.preventDefault();
}
$(window).keydown(function(event){
  if(event.keyCode == 13) {
    event.preventDefault();
    return false;
  }
});

function dr_basic_validation(formSet){
  let success = true;

  let validationResults = [];
  let loopBreak = false;
  $(formSet).find('[data-dr_required=yes]').each(function(e){
    if($(this).data('dr_type') && !loopBreak){
      switch ($(this).data('dr_type')){
        case 'text':
          if( $(this).find('input[type=text]').val() != '' ) {
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        case 'textarea':
          if( $(this).find('textarea').val() != '' ) {
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        case 'radio':
          if( $(this).find('input[type=radio]:checked').val() != undefined && $(this).find('input[type=radio]:checked').val().trim() != "") {
            success = true;
          }else if( $(this).find('input[type=checkbox]:checked').val() != undefined && $(this).find('input[type=checkbox]:checked').val().trim() != "") {
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        case 'select':
          if( $(this).find('select').val() != '') {
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        case 'checkbox':
          if( $(this).find('input[type=checkbox]').is(":checked") ) {
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        case 'file':
          if( $(this).find('input[type=file]')[0].files.length != 0 ) {
            var validation_file_item = $(this).find('input[type=file]')[0];
            var file_ext = (validation_file_item.name).split('.').pop().toLowerCase();
            var accepted_file_ext = $(this).find('input[type=file]').attr('accept').toLowerCase();
            var accepted_file_exts = (accepted_file_ext).split(',');
            
            if($.inArray('.'+file_ext, accepted_file_exts) == -1) {
              
              op_render_alert(formSet, 'Das von Ihnen hochgeladene Dateiformat unterstützen wir nicht. Bitte laden Sie eine Datei in den gängigen Bild-oder Textformaten hoch.');
              reset_dr_file_upload();
              success = false;
              loopBreak = true;
            }else{
              success = true;
            }
            success = true;
          }else{
            success = false;
            loopBreak = true;
          }
          break;
        default:
      }
    }
  });
  
  return success;
}


let dr_order_idle_shown = false;
setIdleTimeout(30000, function() {
    if(!dr_order_idle_shown){
        $('#dr_idle').show();
        dr_order_idle_shown = true;
    }
}, function() { });

function setIdleTimeout(millis, onIdle, onUnidle) {
    var timeout = 0;
    startTimer();

    function startTimer() {
        timeout = setTimeout(onExpires, millis);
        document.addEventListener("mousemove", onActivity);
        document.addEventListener("keypress", onActivity);
    }
    
    function onExpires() {
        timeout = 0;
        onIdle();
    }

    function onActivity() {
        if (timeout) clearTimeout(timeout);
        else onUnidle();
        document.removeEventListener("mousemove", onActivity);
        document.removeEventListener("keypress", onActivity);
        setTimeout(startTimer, 1000);
    }
}

$(document).on('click', '.dr-idle-close', function(e){
    $(this).closest('.dr-idle').hide();
    return false;
});

$(document).on('click', '.dr-idle-close2', function(e){
    $(this).closest('.dr-idle').hide();
});
  

document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
  const dropZoneElement = inputElement.closest(".drop-zone");

  dropZoneElement.addEventListener("click", (e) => {
    if($(e.target).attr('class') == 'dr-zone__reset'){
    }else{
      inputElement.click();
    }
  });

  inputElement.addEventListener("change", (e) => {
    if (inputElement.files.length) {
      updateThumbnail(dropZoneElement, inputElement.files[0], inputElement);
    }
  });

  dropZoneElement.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropZoneElement.classList.add("drop-zone--over");
  });

  ["dragleave", "dragend"].forEach((type) => {
    dropZoneElement.addEventListener(type, (e) => {
      dropZoneElement.classList.remove("drop-zone--over");
    });
  });

  dropZoneElement.addEventListener("drop", (e) => {
    e.preventDefault();

    if (e.dataTransfer.files.length) {
      inputElement.files = e.dataTransfer.files;
      updateThumbnail(dropZoneElement, e.dataTransfer.files[0], inputElement);
    }

    dropZoneElement.classList.remove("drop-zone--over");
  });
});

let promptcopy;
let thumbnailElement;
function updateThumbnail(dropZoneElement, file, file_input) {
  thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

  // First time - remove the prompt
  if (dropZoneElement.querySelector(".drop-zone__prompt")) {
    promptcopy = $(".drop-zone__prompt").clone(true);
    dropZoneElement.querySelector(".drop-zone__prompt").remove();
  }

  // First time - there is no thumbnail element, so lets create it
  if (!thumbnailElement) {
    let removebtnElement = document.createElement("span");
    removebtnElement.classList.add("dr-zone__reset");


    thumbnailElement = document.createElement("div");
    thumbnailElement.classList.add("drop-zone__thumb");
    thumbnailElement.appendChild(removebtnElement);
    dropZoneElement.appendChild(thumbnailElement);
  }

  thumbnailElement.dataset.label = file.name;

  // Show thumbnail for image files
  if (file.type.startsWith("image/")) {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
      thumbnailElement.style.backgroundSize = 'contain';
    };
  } else {
    thumbnailElement.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0608/9847/6257/t/2/assets/dr-upload-file_100x.png?v=8813756892033913527)';
    thumbnailElement.style.backgroundSize = '100px 100px';
  }
  
  var file_ext = (file.name).split('.').pop().toLowerCase();
  var accepted_file_ext = $(file_input).attr('accept').toLowerCase();
  var accepted_file_exts = (accepted_file_ext).split(',');
  
  if($.inArray('.'+file_ext, accepted_file_exts) == -1) {
  	reset_dr_file_upload();
    op_render_alert($(file_input).closest('.dr-op-step'), 'Das von Ihnen hochgeladene Dateiformat unterstützen wir nicht. Bitte laden Sie eine Date in den gängigen Bild-oder Textformaten hoch.');
  }
  
}
$(document).on('click', '.dr-zone__reset', function(){
  reset_dr_file_upload();
});

reset_dr_file_upload();

function reset_dr_file_upload(){
  $('.drop-zone__thumb').remove();
  $('.drop-zone').append(promptcopy);
  $('.drop-zone input[type=file]').val(''); 
  thumbnailElement = null;
  // console.log(thumbnailElement);
}
  


var addOnProcessed = false;
$(document).ready(function(){
  $('.dr-op-submit').prop('disabled', false);
  
  $(document).on('click', '.dr-op-submit', function(e){
    const lastValidation = $(this).closest('.dr-op-step');
    if(dr_basic_validation(lastValidation)){
      $(this).addClass('disabled');
      $(this).prop('disabled', true);
	  console.log('Submitting the Order...');
      if(!addOnProcessed){
      	dr_product_submission();
        return false;
      }else{
        return true;
      }
    }else{
		// Do not submit!
   		alert('Invalid Entry'); 
    	e.preventDefault();
    }
  });
});

function dr_product_submission(){
  var formEl = 'form.shopify-product-form';

  var dr_data = { items: [] };
  
  if($(formEl).find('*[data-dr_addon]').length){
    var addon_data_empty = true;
    $(formEl).find('*[data-dr_addon]').each(function(){
      var addon_id = null;
      
      if($(this).is(':checkbox') && $(this).is(':checked')){
       	 addon_id = $(this).val();
      }
      
      if($(this).is('select')){
       	 addon_id = $(this).val();
      }
                               
      if(addon_id != null && addon_id != '' && (addon_id != 0 || addon_id != "0")){
        var addon_data = { quantity: 1, id: addon_id };
        dr_data['items'].push(addon_data);
        addon_data_empty = false;
      }
    });
    
    if(!addon_data_empty){
      $.ajax({
        type: "post",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
          $.ajax({
            type: 'post',
            url: '/cart/add.js',
            data: dr_data,
            success: function(result_data){
              addOnProcessed = true;
              $(formEl).submit();
            },
            dataType: 'json'
          });
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log('There has been an error! Please contact us');
        }
      });
    }else{
      $.ajax({
        type: "post",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { },
        error: function(XMLHttpRequest, textStatus) {
          console.log('There has been an error! Please contact us');
        }
      });
      
      addOnProcessed = true;
      $(formEl).submit(); 
    }
  }else{
    addOnProcessed = true;
    $(formEl).submit();
  }
}

function dr_unique_list(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}